import { atom } from 'recoil';
import { INivelDeCargo } from '../../../commons/types/config';

export const nivelDeCargoAtom = atom<INivelDeCargo[]>({
  key: 'niveisDeCargos',
  default: [] as INivelDeCargo[],
});
